import { ContextTracker, ExternalTokenizer, LRParser } from '@lezer/lr';
import { styleTags, tags } from '@lezer/highlight';
import { parser as parser$1 } from '@glimdown/lezer-glimmer-expression';
import { parseMixed } from '@lezer/common';

// This file was generated by lezer-generator. You probably shouldn't edit it.
const scriptText = 116,
  StartCloseScriptTag = 1,
  styleText = 117,
  StartCloseStyleTag = 2,
  textareaText = 118,
  StartCloseTextareaTag = 3,
  StartTag = 4,
  StartScriptTag = 5,
  StartStyleTag = 6,
  StartTextareaTag = 7,
  StartSelfClosingTag = 8,
  StartCloseTag = 9,
  MismatchedStartCloseTag = 11,
  missingCloseTag = 119,
  IncompleteCloseTag = 12,
  commentContent$1 = 120,
  moustacheCommentContent$1 = 121,
  longMoustacheCommentContent$1 = 122,
  LongExpression = 13,
  Element = 59,
  ScriptText = 81,
  StyleText = 84,
  TextareaText = 87,
  OpenTag = 89;

const selfClosers = {
  area: true,
  base: true,
  br: true,
  col: true,
  command: true,
  embed: true,
  frame: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true,
  menuitem: true,
};

const implicitlyClosed = {
  dd: true,
  li: true,
  optgroup: true,
  option: true,
  p: true,
  rp: true,
  rt: true,
  tbody: true,
  td: true,
  tfoot: true,
  th: true,
  tr: true,
};

const closeOnOpen = {
  dd: { dd: true, dt: true },
  dt: { dd: true, dt: true },
  li: { li: true },
  option: { option: true, optgroup: true },
  optgroup: { optgroup: true },
  p: {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    dir: true,
    div: true,
    dl: true,
    fieldset: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    menu: true,
    nav: true,
    ol: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    ul: true,
  },
  rp: { rp: true, rt: true },
  rt: { rp: true, rt: true },
  tbody: { tbody: true, tfoot: true },
  td: { td: true, th: true },
  tfoot: { tbody: true },
  th: { td: true, th: true },
  thead: { tbody: true, tfoot: true },
  tr: { tr: true },
};

function nameChar(ch) {
  return (
    ch == 45 ||
    ch == 46 ||
    ch == 58 ||
    (ch >= 65 && ch <= 90) ||
    ch == 95 ||
    (ch >= 97 && ch <= 122) ||
    ch >= 161
  );
}

function isSpace(ch) {
  return ch == 9 || ch == 10 || ch == 13 || ch == 32;
}

let cachedName = null,
  cachedInput = null,
  cachedPos = 0;

function tagNameAfter(input, offset) {
  let pos = input.pos + offset;

  if (cachedPos == pos && cachedInput == input) return cachedName;

  let next = input.peek(offset);

  while (isSpace(next)) next = input.peek(++offset);

  let name = '';

  for (;;) {
    if (!nameChar(next)) break;
    name += String.fromCharCode(next);
    next = input.peek(++offset);
  }

  // Undefined to signal there's a <? or <!, null for just missing
  cachedInput = input;
  cachedPos = pos;

  return (cachedName = name
    ? name.toLowerCase()
    : next == question || next == bang
      ? undefined
      : null);
}

const lessThan = 60,
  greaterThan$1 = 62,
  slash$1 = 47,
  question = 63,
  bang = 33;
// dash = 45;

function ElementContext(name, parent) {
  this.name = name;
  this.parent = parent;
  this.hash = parent ? parent.hash : 0;
  for (let i = 0; i < name.length; i++)
    this.hash += (this.hash << 4) + name.charCodeAt(i) + (name.charCodeAt(i) << 8);
}

const startTagTerms = [
  StartTag,
  StartSelfClosingTag,
  StartScriptTag,
  StartStyleTag,
  StartTextareaTag,
];

const elementContext = /*@__PURE__*/new ContextTracker({
  start: null,
  shift(context, term, stack, input) {
    return startTagTerms.indexOf(term) > -1
      ? new ElementContext(tagNameAfter(input, 1) || '', context)
      : context;
  },
  reduce(context, term) {
    return term == Element && context ? context.parent : context;
  },
  reuse(context, node, stack, input) {
    let type = node.type.id;

    return type == StartTag || type == OpenTag
      ? new ElementContext(tagNameAfter(input, 1) || '', context)
      : context;
  },
  hash(context) {
    return context ? context.hash : 0;
  },
  strict: false,
});

const tagStart = /*@__PURE__*/new ExternalTokenizer(
  (input, stack) => {
    if (input.next != lessThan) {
      // End of file, close any open tags
      if (input.next < 0 && stack.context) input.acceptToken(missingCloseTag);

      return;
    }

    input.advance();

    let close = input.next == slash$1;

    if (close) input.advance();

    let name = tagNameAfter(input, 0);

    if (name === undefined) return;
    if (!name) return input.acceptToken(close ? IncompleteCloseTag : StartTag);

    let parent = stack.context ? stack.context.name : null;

    if (close) {
      if (name == parent) return input.acceptToken(StartCloseTag);
      if (parent && implicitlyClosed[parent]) return input.acceptToken(missingCloseTag, -2);
      // if (stack.dialectEnabled(Dialect_noMatch)) return input.acceptToken(NoMatchStartCloseTag)
      for (let cx = stack.context; cx; cx = cx.parent) if (cx.name == name) return;
      input.acceptToken(MismatchedStartCloseTag);
    } else {
      if (name == 'script') return input.acceptToken(StartScriptTag);
      if (name == 'style') return input.acceptToken(StartStyleTag);
      if (name == 'textarea') return input.acceptToken(StartTextareaTag);
      if (name in selfClosers) return input.acceptToken(StartSelfClosingTag);
      if (parent && closeOnOpen[parent] && closeOnOpen[parent][name])
        input.acceptToken(missingCloseTag, -1);
      else input.acceptToken(StartTag);
    }
  },
  { contextual: true }
);

function contentTokenizer(tag, textToken, endToken) {
  let lastState = 2 + tag.length;

  return new ExternalTokenizer((input) => {
    // state means:
    // - 0 nothing matched
    // - 1 '<' matched
    // - 2 '</' + possibly whitespace matched
    // - 3-(1+tag.length) part of the tag matched
    // - lastState whole tag + possibly whitespace matched
    for (let state = 0, matchedLen = 0, i = 0; ; i++) {
      if (input.next < 0) {
        if (i) input.acceptToken(textToken);

        break;
      }

      if (
        (state == 0 && input.next == lessThan) ||
        (state == 1 && input.next == slash$1) ||
        (state >= 2 && state < lastState && input.next == tag.charCodeAt(state - 2))
      ) {
        state++;
        matchedLen++;
      } else if ((state == 2 || state == lastState) && isSpace(input.next)) {
        matchedLen++;
      } else if (state == lastState && input.next == greaterThan$1) {
        if (i > matchedLen) input.acceptToken(textToken, -matchedLen);
        else input.acceptToken(endToken, -(matchedLen - 2));

        break;
      } else if ((input.next == 10 /* '\n' */ || input.next == 13) /* '\r' */ && i) {
        input.acceptToken(textToken, 1);

        break;
      } else {
        state = matchedLen = 0;
      }

      input.advance();
    }
  });
}

const scriptTokens = /*@__PURE__*/contentTokenizer('script', scriptText, StartCloseScriptTag);

const styleTokens = /*@__PURE__*/contentTokenizer('style', styleText, StartCloseStyleTag);

const textareaTokens = /*@__PURE__*/contentTokenizer('textarea', textareaText, StartCloseTextareaTag);

const space = [
    9, 10, 11, 12, 13, 32, 133, 160, 5760, 8192, 8193, 8194, 8195, 8196, 8197, 8198, 8199, 8200, 8201,
    8202, 8232, 8233, 8239, 8287, 12288,
];
const parenOpen = 40;
const parenClose = 41;
const squareOpen = 91;
const squareClose = 93;
const curlyOpen = 123;
const curlyClose = 125;
const colon = 58;
const hash = 35;
const slash = 47;
const greaterThan = 62;
const dash = 45;
const quoteDouble = 34;
const quoteSingle = 39;
const backslash = 92;
const newline = 10;
const asterisk = 42;
const tick = 96;
const tilde = 126;
/**
 * Characters that begin a block ("{{#if", "{{/if", "{{:else").
 * Blocks are parsed by the grammar, not as an expression.
 */
const blockPrefixes = [colon, hash, slash];
const elseWord = [101, 108, 115, 101];
function scanTo(type, end) {
    return new ExternalTokenizer((input) => {
        for (let endPos = 0, len = 0;; len++) {
            if (input.next < 0) {
                if (len)
                    input.acceptToken(type);
                break;
            }
            if (input.next == end.charCodeAt(endPos)) {
                endPos++;
                if (endPos == end.length) {
                    if (len >= end.length)
                        input.acceptToken(type, 1 - end.length);
                    break;
                }
            }
            else {
                endPos = input.next == end.charCodeAt(0) ? 1 : 0;
            }
            input.advance();
        }
    });
}
const moustacheCommentContent = /*@__PURE__*/scanTo(moustacheCommentContent$1, '}}');
const longMoustacheCommentContent = /*@__PURE__*/scanTo(longMoustacheCommentContent$1, '--}}');
const commentContent = /*@__PURE__*/new ExternalTokenizer((input) => {
    for (let dashes = 0, i = 0;; i++) {
        if (input.next < 0) {
            if (i)
                input.acceptToken(commentContent$1);
            break;
        }
        if (input.next == dash) {
            dashes++;
        }
        else if (input.next == greaterThan && dashes >= 2) {
            if (i > 3)
                input.acceptToken(commentContent$1, -2);
            break;
        }
        else {
            dashes = 0;
        }
        input.advance();
    }
});
/**
 * "{{else}}" and "{{else if x}}" are block syntax, so the grammar
 * must see the "else" keyword instead of an expression.
 */
function startsWithElse(input) {
    for (let i = 0; i < elseWord.length; i++) {
        if (input.peek(i) !== elseWord[i])
            return false;
    }
    const next = input.peek(elseWord.length);
    return next < 0 || next === curlyClose || next === tilde || space.includes(next);
}
function createStringHandler(input) {
    let inString = false;
    let inStringType = null;
    let inStringIgnoreNext = false;
    return () => {
        if (inString) {
            if (inStringIgnoreNext) {
                inStringIgnoreNext = false;
                return true;
            }
            if (input.next === backslash) {
                inStringIgnoreNext = true;
                return true;
            }
            if (inStringType === 'double' && input.next === quoteDouble) {
                inString = false;
                inStringType = null;
                return true;
            }
            if (inStringType === 'single' && input.next === quoteSingle) {
                inString = false;
                inStringType = null;
                return true;
            }
            if (inStringType === 'template' && input.next === tick) {
                inString = false;
                inStringType = null;
                return true;
            }
            return true;
        }
        if (input.next === quoteDouble) {
            inString = true;
            inStringType = 'double';
            return true;
        }
        if (input.next === quoteSingle) {
            inString = true;
            inStringType = 'single';
            return true;
        }
        if (input.next === tick) {
            inString = true;
            inStringType = 'template';
            return true;
        }
        return false;
    };
}
function createCommentHandler(input) {
    let inLineComment = false;
    let inBlockComment = false;
    return () => {
        if (inLineComment) {
            if (input.next === newline) {
                inLineComment = false;
                return true;
            }
            return true;
        }
        if (inBlockComment) {
            if (input.next === asterisk && input.peek(1) === slash) {
                inBlockComment = false;
                return true;
            }
            return true;
        }
        if (input.next === slash && input.peek(1) === slash) {
            inLineComment = true;
            return true;
        }
        if (input.next === slash && input.peek(1) === asterisk) {
            inBlockComment = true;
            return true;
        }
        return false;
    };
}
// closes on a delimiter that probably isn't in the expression
const longExpression = /*@__PURE__*/new ExternalTokenizer((input) => {
    if (blockPrefixes.includes(input.next)) {
        return;
    }
    if (startsWithElse(input)) {
        return;
    }
    const commentHandler = createCommentHandler(input);
    const stringHandler = createStringHandler(input);
    let stack = [];
    const popIfMatch = (match) => {
        const idx = stack.lastIndexOf(match);
        if (idx !== -1) {
            while (stack.length > idx) {
                stack.pop();
            }
        }
    };
    for (let pos = 0;; pos++) {
        // end of input
        if (input.next < 0) {
            if (pos > 0)
                input.acceptToken(LongExpression);
            break;
        }
        if (commentHandler() || stringHandler()) {
            input.advance();
            continue;
        }
        if (stack.length === 0 &&
            (input.next === curlyClose || input.next === parenClose || input.next === squareClose)) {
            input.acceptToken(LongExpression);
            break;
        }
        // prettier-ignore
        switch (input.next) {
            case parenOpen:
                stack.push("(");
                break;
            case parenClose:
                popIfMatch("(");
                break;
            case squareOpen:
                stack.push("[");
                break;
            case squareClose:
                popIfMatch("[");
                break;
            case curlyOpen:
                stack.push("{");
                break;
            case curlyClose:
                popIfMatch("{");
                break;
        }
        input.advance();
    }
});

const glimmerHighlighting = /*@__PURE__*/styleTags({
    'Comment MoustacheComment LongMoustacheComment': tags.blockComment,
    Text: tags.content,
    'StartTag StartCloseTag SelfClosingEndTag EndTag': tags.angleBracket,
    TagName: tags.tagName,
    NamedBlock: tags.tagName,
    ComponentName: tags.className,
    'MismatchedCloseTag/TagName': [tags.tagName, tags.invalid],
    AttributeName: tags.attributeName,
    StyleAttributeName: tags.propertyName,
    UnquotedAttributeValue: tags.attributeValue,
    'DoubleQuote SingleQuote AttributeValueContent': tags.attributeValue,
    Is: tags.definitionOperator,
    Splattributes: tags.derefOperator,
    as: tags.definitionKeyword,
    'BlockParam/AttributeName': /*@__PURE__*/tags.definition(tags.variableName),
    '|': tags.punctuation,
    '{{ }} {{{ }}}': tags.brace,
    BlockPrefix: tags.controlKeyword,
    BlockType: tags.controlKeyword,
    if: tags.controlKeyword,
    'UnknownBlock/BlockType': tags.invalid,
    UnknownBlockContent: tags.invalid,
    'EntityReference CharacterReference': tags.character,
    InvalidEntity: tags.invalid,
    ProcessingInst: tags.processingInstruction,
    DoctypeDecl: tags.documentMeta,
});

// This file was generated by lezer-generator. You probably shouldn't edit it.
const spec_BlockPrefix = {__proto__:null,"#":39, ":":49, "/":57};
const spec_BlockType = {__proto__:null,if:42, else:50, unless:62, let:70, each:78, "each-in":86, "in-element":94};
const spec_identifier = {__proto__:null,if:52};
const spec_AttributeName = {__proto__:null,as:130};
const parser = /*@__PURE__*/LRParser.deserialize({
  version: 14,
  states: "=dQVO&rOOO!dO&rO'#CkO#nO&rO'#CyO$xO&rO'#C}O&SO&rO'#DRO'^O&rO'#DVO(hO&rO'#DZO)rQ.zO'#D_O)wQ.zO'#DbO*SQ,UO'#DjO*XQ,UO'#ERO*^Q,UO'#EUO*cQ7[O'#EXO*nQ,UO'#E]O*sOXO'#DiO+OOYO'#DiO+ZO[O'#DiO,sO&rO'#DiOOOW'#Di'#DiO,zO-hO'#E_O-SO,vO'#E`O-[O,fO'#EaO*cQ7[O'#EcO*cQ7[O'#EdOOOW'#E}'#E}OOOW'#Ef'#EfQVO&rOOOOOW'#Eg'#EgO!dO&rO,59VOOOW,59V,59VO-uQ!!^O'#DbO#nO&rO,59eOOOW,59e,59eO-|Q!!^O'#DbOOOW'#Eh'#EhO$xO&rO,59iOOOW,59i,59iO.TQ.zO'#DbO&SO&rO,59mOOOW,59m,59mO.cQ!!^O'#DbO'^O&rO,59qOOOW,59q,59qO.jQ!!^O'#DbO(hO&rO,59uOOOW,59u,59uO.qQ.zO'#DbO/PQ7[O,59yO/UQMhO,59|O/ZQMhO,59}O/`QMhO,59WO0VQ!LQO,5:UO0^Q!LQO,5:mO0eQ!LQO,5:pOOQO'#FU'#FUO0lQ!LQO,5:sO0vQ!LQO,5:wOOOX'#Em'#EmO0}OXO'#EPO1YOXO,5:TOOOY'#En'#EnO1bOYO'#ESO1mOYO,5:TOOO['#Eo'#EoO1uO[O'#EVO2QO[O,5:TO2YO&rO,5:TO*cQ7[O'#E[OOOW,5:T,5:TOOO!b'#Ep'#EpO2aO-hO,5:yOOOW,5:y,5:yOOOp'#Eq'#EqO2iO,vO,5:zOOOW,5:z,5:zOOO`'#Er'#ErO2qO,fO,5:{OOOW,5:{,5:{O2yQ7[O,5:}O3OQ7[O,5;OOOOW-E8d-E8dOOOW-E8e-E8eOOOW1G.q1G.qO3TQ$ISO,59_O3]QMhO,59_O3bQMhO,59cOOOW1G/P1G/PO3gQMhO,59hOOOW-E8f-E8fOOOW1G/T1G/TO3lQMhO,59lOOOW1G/X1G/XO3qQMhO,59pOOOW1G/]1G/]O3vQMhO,59tOOOW1G/a1G/aO3{QMhO,59xOOOW1G/e1G/eOOOW1G/h1G/hO4QQ(CWO1G/iO4YQ.zO1G.rO4_Q.zO1G/QO4dQ.zO1G/UO4iQ.zO1G/YO4nQ.zO1G/^O4sQ.zO1G/bO4xQ.zO'#DlO4}Q!LQO'#DrO5iQ!LQO'#D{O6TQ07`O'#D|OOQO'#FP'#FPOOQO'#Ei'#EiO6YQ!LQO1G/pOOOX1G/p1G/pO6aQ!LQO'#D{O6hQ!LQO1G0XOOOY1G0X1G0XO6oQ!LQO1G0[OOO[1G0[1G0[O6vQ!LQO1G0_OOOW1G0_1G0_OOOW1G0c1G0cO7QQ!LQO1G0cOOOX-E8k-E8kO7XQ,UO'#EQOOOW1G/o1G/oOOOY-E8l-E8lO7^Q,UO'#ETOOO[-E8m-E8mO7cQ,UO'#EWO7hQ7[O,5:vOOO!b-E8n-E8nOOOW1G0e1G0eOOOp-E8o-E8oOOOW1G0f1G0fOOO`-E8p-E8pOOOW1G0g1G0gOOOW1G0i1G0iOOOW1G0j1G0jP-dQ!!^O'#DbOOOW1G.y1G.yO7mQ.zO1G.yO7rQ$ISO1G.yO7zQMhO1G.}O8PQMhO1G/SO8UQMhO1G/WO8ZQMhO1G/[O8`QMhO1G/`O8eQMhO1G/dOOOW7+%T7+%TO8jQMhO7+%TO8oQMhO7+$^O8tQMhO7+$lO8yQMhO7+$pO9OQMhO7+$tO9TQMhO7+$xO9YQMhO7+$|O9_QMhO,5:WO9dQ?MpO,5:^O9rQ?MpO,5:gOOQO,5:h,5:hOOQO-E8g-E8gOOOX7+%[7+%[O:QQ!LQO,5:XOOOY7+%s7+%sOOO[7+%v7+%vOOOW7+%y7+%yOOOW7+%}7+%}O:YQ7[O,5:lO:_Q7[O,5:oO:dQ7[O,5:rOOOW1G0b1G0bO:iQMhO7+$eOOOW7+$e7+$eO:nQ.zO7+$eOOOW7+$i7+$iOOOW7+$n7+$nOOOW7+$r7+$rOOOW7+$v7+$vOOOW7+$z7+$zOOOW7+%O7+%OOOOW<<Ho<<HoOOOW<<Gx<<GxOOOW<<HW<<HWOOOW<<H[<<H[OOOW<<H`<<H`OOOW<<Hd<<HdOOOW<<Hh<<HhOOQO1G/r1G/rO:sQ.zO'#DbOOQO'#Du'#DuO;ZO!0LbO'#DuO;sO#@ItO'#DuOOQO1G/x1G/xOOQO1G0R1G0ROOQO'#Dq'#DqOOQO'#Ej'#EjO;zQ!LQO1G/sOOQO1G/s1G/sOOOW1G0W1G0WOOOW1G0Z1G0ZOOOW1G0^1G0^OOOW<<HP<<HPO<SQMhO<<HPOOOO'#FR'#FROOOO'#Ek'#EkO<XO!0LbO'#DwOOQO,5:a,5:aO<`O,UO,5:aOOOO'#El'#ElO<eO#@ItO'#DyO<lO,UO,5:aOOQO-E8h-E8hOOQO7+%_7+%_OOOWAN=kAN=kOOOO-E8i-E8iOOQO1G/{1G/{OOOO-E8j-E8j",
  stateData: "=R~O#pOS~OS[OTXOUYOVZOW]OYgOZfO[hOaWO!SVO!XhO!YhO!ZhO![hO#UhO#XiO#ycO#{dO#}eO~OS[OTXOUYOVZOW]OYgOZfO[hOanO!SVO!XhO!YhO!ZhO![hO#UhO#ycO#{dO#}eO~OS[OTXOUYOVZOW]OYgOZfO[hOaqO!SVO!XhO!YhO!ZhO![hO#UhO#ycO#{dO#}eO~OS[OTXOUYOVZOW]OYgOZfO[hOauO!SVO!XhO!YhO!ZhO![hO#UhO#ycO#{dO#}eO~OS[OTXOUYOVZOW]OYgOZfO[hOaxO!SVO!XhO!YhO!ZhO![hO#UhO#ycO#{dO#}eO~OS[OTXOUYOVZOW]OYgOZfO[hOa{O!SVO!XhO!YhO!ZhO![hO#UhO#ycO#{dO#}eO~OS[OTXOUYOVZOW]OYgOZfO[hOa!OO!SVO!XhO!YhO!ZhO![hO#UhO#ycO#{dO#}eO~O]!PO~O]!QOb!ROc!SO~O!_!TO~O!_!UO~O!_!VO~O!_!WO!|!WO!}!WO~O!_!YO~O#h!ZOP!sP#k!sP~O#i!^OQ!vP#k!vP~O#j!aOR!yP#k!yP~OS[OTXOUYOVZOW]OX!eOYgOZfO[hOaWO!SVO!XhO!YhO!ZhO![hO#UhO#ycO#{dO#}eO~O#k!fO~P+fO#n!gO#z!iO~O#m!jO#|!lO~O#l!mO$O!oO~O]!QOb!ROc!SOh!vOi!uO~Ol!wO~P-dOl!yO~P-dO]!QOb!ROc!SOl!|O~Ol#OO~P-dOl#QO~P-dO]!QOb!ROc!SOl#SO~O!T#TO~Of#UO~Od#VO~Oe#WOo#XOs#YOw#ZO{#[O!P#]O~Oa#^O!b#`O!c#fO!g#_O!q#aO~O!r#eO~P/tO!r#hO~P/tO!r#jO~P/tO!r#lO#Q#mO~P/tO!r#mO~P/tO#h!ZOP!sX#k!sX~OP#pO#k#qO~O#i!^OQ!vX#k!vX~OQ#sO#k#qO~O#j!aOR!yX#k!yX~OR#uO#k#qO~O#k#qO~P+fO#n!gO#z#xO~O#m!jO#|#zO~O#l!mO$O#|O~O!r#}O~O!r$OO~Of$QOj$RO~Oi$SO~Oe$TO~Oo$UO~Os$VO~Ow$WO~O{$XO~O!P$YO~Of$ZO!W$[O~O]$]O~O]$^O~O]$_O~O]$`O~O]$aO~O]$bO~O]$cO~O!h$dOa!fX!b!fX!c!fX!g!fX!q!fX!r!fX#Q!fX~O!h$eOa!oX!b!oX!c!oX!g!oX!q!oX!r!oX#Q!oX~O#w$fO~O!r$hO~P/tO!d$iO~P5iO!r$jO~P/tO!r$kO~P/tO!r$lO#Q$mO~P/tO!r$mO~P/tO!_$nO~O!_$oO~O!_$pO~O!r$qO~O]$rO~Of$sOj$tO~Of$uO~Of$vO~Of$wO~Of$xO~Of$yO~Of$zO~Of${O~Of$|O~Of$}O~Of%OO~Of%PO~Of%QO~Of%RO~Of%SO~Oa%TO!j%VO!l%WO!n%XO~Oa%TO!j%VO!l%WO!n%YO~O!b%ZO!d%^O~O!r%_O~O!r%`O~O!r%aO~Of%bO~O]%cO~O]!QO~Oa%TO!Y%dO!Z%dO![%dO#t%eO~O!j%gO~P:xOa%TO!Y%dO!Z%dO![%dO#v%iO~O!l%gO~P;bO!b%ZO!d%mO~Of%nO~O!j!kX~P:xO!j%pO~O!l!mX~P;bO!l%pO~O!W#p#Q#}#U#X#y#{!Z!Y![!r!g!b!g~",
  goto: "/O#yPPPPPPPPPPPPPPP#z$^PPPPPP$pPPP$zP#z%QP%d#z%jP%|#z&SP&f#z&lP'O#z'UP'h#zPP'n#zPPPPP#z([P(n(nPPP(z(nPP)OP)UP)XP(n(nPP)[)_)b)t)w)z*^*a*dPP*v*|P#z#z#zP#z#zP+`+f+x,W,n,t,z-Q-W-^-d-j-pPPPPPPPPPP-vP.^P.jPP.rqhOPQRSTUajlosvy|!dqPOPQRSTUajlosvy|!dakPQSTlovyQmPR!tlqQOPQRSTUajlosvy|!dQpQR!xoqROPQRSTUajlosvy|!dQtRR!{sqSOPQRSTUajlosvy|!dQwSR!}vqTOPQRSTUajlosvy|!dQzTR#PyqUOPQRSTUajlosvy|!dQ}UR#R|phOPQRSTUajlosvy|!dS%U$d$eX%d%V%W%f%jq^OPQRSTUajlosvy|!de#b!T!U!V!X!Y#d#g#i#k#nT%[$i%]Q%X$dR%Y$eR%h%VR%k%WR!]^R#q!]q_OPQRSTUajlosvy|!dR!`_R#q!`q`OPQRSTUajlosvy|!dR!c`R#q!cqaOPQRSTUajlosvy|!dQ!faR#q!dqbOPQRSTUajlosvy|!dQjOR!rjQlPQoQQvSQyTX!slovyQsRQ|UQ!daV!zs|!dQ#d!TQ#g!UQ#i!VQ#k!XQ#n!YZ$g#d#g#i#k#nQ%]$iR%l%]Q%f%VR%o%fQ%j%WR%q%jQ![^R#o![Q!__R#r!_Q!b`R#t!bQ!hcR#w!hQ!kdR#y!kQ!neR#{!nSiOj`kPQSTlovy]rRUas|!de#c!T!U!V!X!Y#d#g#i#k#nS%e%V%fT%i%W%jQ!X[Q!pfQ!qgR#v!e",
  nodeNames: "⚠ StartCloseTag StartCloseTag StartCloseTag StartTag StartTag StartTag StartTag StartTag StartCloseTag StartCloseTag StartCloseTag IncompleteCloseTag LongExpression Document IfBlock IfBlockOpen {{ BlockPrefix BlockPrefix BlockType BlockType }} ElseBlock BlockPrefix BlockType if IfBlockClose BlockPrefix UnlessBlock UnlessBlockOpen BlockType UnlessBlockClose LetBlock LetBlockOpen BlockType LetBlockClose EachBlock EachBlockOpen BlockType EachBlockClose EachInBlock EachInBlockOpen BlockType EachInBlockClose InElementBlock InElementBlockOpen BlockType InElementBlockClose RawHTMLBlock {{{ }}} Interpolation UnknownBlock UnknownBlockContent Text EntityReference CharacterReference InvalidEntity Element OpenTag TagName ElementModifier BlockParams AttributeName as | BlockParam StyleAttribute StyleAttributeName Is AttributeValue DoubleQuote AttributeValueContent SingleQuote AttributeValueContent UnquotedAttributeValue Attribute Splattributes ... EndTag ScriptText CloseTag OpenTag StyleText CloseTag OpenTag TextareaText CloseTag OpenTag NamedBlock ComponentName CloseTag SelfClosingTag SelfClosingEndTag LongMoustacheComment MoustacheComment Comment ProcessingInst MismatchedCloseTag CloseTag DoctypeDecl",
  maxTerm: 138,
  context: elementContext,
  nodeProps: [
    ["closedBy", -10,1,2,3,5,6,7,8,9,10,11,"EndTag",4,"EndTag SelfClosingEndTag",16,"IfBlockClose",17,"}}",30,"UnlessBlockClose",34,"LetBlockClose",38,"EachBlockClose",42,"EachInBlockClose",46,"InElementBlockClose",50,"}}}",-4,60,83,86,89,"CloseTag",72,"\"",74,"'"],
    ["group", -12,12,52,56,57,58,59,95,96,97,98,99,100,"Entity",-6,15,29,33,37,41,45,"Block Entity",-6,16,30,34,38,42,46,"BlockOpen",23,"BlockInline",-6,27,32,36,40,44,48,"BlockClose",-2,49,53,"BlockInline Entity",55,"Entity TextContent",-3,81,84,87,"TextContent Entity"],
    ["openedBy", 22,"{{",27,"IfBlockOpen",32,"UnlessBlockOpen",36,"LetBlockOpen",40,"EachBlockOpen",44,"EachInBlockOpen",48,"InElementBlockOpen",51,"{{{",72,"\"",74,"'",80,"StartTag StartCloseTag",-4,82,85,88,92,"OpenTag",94,"StartTag"]
  ],
  propSources: [glimmerHighlighting],
  skippedNodes: [0],
  repeatNodeCount: 13,
  tokenData: "&E}MgR!aOX%WXY.zYZ.zZ[%W[]1r]^.z^p%Wpq.zqr2prsC]stDZtuFjuv2pvwN|wx# Yx}2p}!O#!W!O!P#:q!P!Q#@X!Q![2p![!]#CQ!]!^2p!^!_$ P!_!`$HZ!`!a$IZ!a!c2p!c!}$JZ!}#R2p#R#S%)a#S#T%6g#T#U%8]#U#o%)a#o#p&7q#p#q&:s#q#r&<k#r#s2p#s$f%W$f$g2p$g%WFj%W%o%)a%o%pFj%p&a%)a&a&bFj&b1p%)a1p4UFj4U4d%)a4d4eFj4e$IS%)a$IS$I`Fj$I`$Ib%)a$Ib$KhFj$Kh%#t%)a%#t&/xFj&/x&Et%)a&Et&FVFj&FV;'S%)a;'S;:j&CX;:j;=`&C_<%l?&rFj?&r?Ah%)a?Ah?BY&Ce?BY?Mn%)a?MnO&CeIa%eg!XP!n&j#t,U#v7[!W!bOX&|XZ(nZ[&|[^(n^p&|pq(nqr&|rs(nsv&|vw*twx(nx!^&|!^!_)h!_!a(n!a#S&|#S#T(n#T#o&|#o#p*t#p#q&|#q#r-X#r;'S&|;'S;=`.t<%lO&|'}'Vg!XP!n&j!W!bOX&|XZ(nZ[&|[^(n^p&|pq(nqr&|rs(nsv&|vw*twx(nx!^&|!^!_)h!_!a(n!a#S&|#S#T(n#T#o&|#o#p*t#p#q&|#q#r-X#r;'S&|;'S;=`.t<%lO&|!c(uZ!XP!W!bOv(nvw)hw!^(n!^!_)h!_#o(n#o#p)h#p#q(n#q#r*P#r;'S(n;'S;=`*n<%lO(n!b)mS!W!bO#q)h#r;'S)h;'S;=`)y<%lO)h!b)|P;=`<%l)hP*UU!XPOv*Pw!^*P!_#o*P#p;'S*P;'S;=`*h<%lO*PP*kP;=`<%l*P!c*qP;=`<%l(n'|*{c!n&j!W!bOX*tXZ)hZ[*t[^)h^p*tpq)hqr*trs)hsw*twx)hx!^*t!^!a)h!a#S*t#S#T)h#T#q*t#q#r,W#r;'S*t;'S;=`-R<%lO*t&j,]Y!n&jOX,WZ[,W^p,Wqr,Wsw,Wx!^,W!a#S,W#T;'S,W;'S;=`,{<%lO,W&j-OP;=`<%l,W'|-UP;=`<%l*t&k-`d!XP!n&jOX-XXZ*PZ[-X[^*P^p-Xpq*Pqr-Xrs*Psv-Xvw,Wwx*Px!^-X!_!a*P!a#S-X#S#T*P#T#o-X#o#p,W#p;'S-X;'S;=`.n<%lO-X&k.qP;=`<%l-X'}.wP;=`<%l&|Mg/Xb!XP#t,U#v7[!W!b#p,SOX(nXY0aYZ0aZ](n]^0a^p(npq0aqv(nvw)hw!^(n!^!_)h!_#o(n#o#p)h#p#q(n#q#r*P#r;'S(n;'S;=`*n<%lO(n,T0jb!XP!W!b#p,SOX(nXY0aYZ0aZ](n]^0a^p(npq0aqv(nvw)hw!^(n!^!_)h!_#o(n#o#p)h#p#q(n#q#r*P#r;'S(n;'S;=`*n<%lO(nCu1}Z!XP#t,U#v7[!W!bOv(nvw)hw!^(n!^!_)h!_#o(n#o#p)h#p#q(n#q#r*P#r;'S(n;'S;=`*n<%lO(nIq3Pn!XP!n&j#t,U#v7[!W!b!b`OX&|XZ(nZ[&|[^(n^p&|pq(nqr4}rs(nsv4}vw7Wwx(nx!O4}!O!Q&|!Q!^4}!^!_9X!_!a(n!a#S4}#S#T=e#T#o4}#o#p*t#p#q&|#q#r@{#r#s4}#s$f&|$f;'S4};'S;=`CV<%l?Ah4}?Ah?BY&|?BY?Mn4}?MnO&|(_5Yn!XP!n&j!W!b!b`OX&|XZ(nZ[&|[^(n^p&|pq(nqr4}rs(nsv4}vw7Wwx(nx!O4}!O!Q&|!Q!^4}!^!_9X!_!a(n!a#S4}#S#T=e#T#o4}#o#p*t#p#q&|#q#r@{#r#s4}#s$f&|$f;'S4};'S;=`CV<%l?Ah4}?Ah?BY&|?BY?Mn4}?MnO&|(^7al!n&j!W!b!b`OX*tXZ)hZ[*t[^)h^p*tpq)hqr7Wrs)hsw7Wwx)hx!O7W!O!Q*t!Q!^7W!^!_9X!_!a)h!a#S7W#S#T9X#T#o7W#o#q*t#q#r;o#r#s7W#s$f*t$f;'S7W;'S;=`=_<%l?Ah7W?Ah?BY*t?BY?Mn7W?MnO*t!r9`d!W!b!b`Oq)hqr9Xrs)hsw9Xwx)hx!O9X!O!Q)h!Q!_9X!_!a)h!a#o9X#o#q)h#q#r:n#r#s9X#s$f)h$f;'S9X;'S;=`;i<%l?Ah9X?Ah?BY)h?BY?Mn9X?MnO)h`:sY!b`qr:nsw:nx!O:n!Q!_:n!a#o:n#q#s:n$f;'S:n;'S;=`;c<%l?Ah:n?BY?Mn:n`;fP;=`<%l:n!r;lP;=`<%l9X&z;ve!n&j!b`OX,WZ[,W^p,Wqr;osw;ox!O;o!O!Q,W!Q!^;o!^!_:n!a#S;o#S#T:n#T#o;o#o#q,W#q#s;o#s$f,W$f;'S;o;'S;=`=X<%l?Ah;o?Ah?BY,W?BY?Mn;o?MnO,W&z=[P;=`<%l;o(^=bP;=`<%l7W!s=ng!XP!W!b!b`Oq(nqr=ers(nsv=evw9Xwx(nx!O=e!O!Q(n!Q!^=e!^!_9X!_!a(n!a#o=e#o#p)h#p#q(n#q#r?V#r#s=e#s$f(n$f;'S=e;'S;=`@u<%l?Ah=e?Ah?BY(n?BY?Mn=e?MnO(na?^e!XP!b`Oq*Pqr?Vrs*Psv?Vvw:nwx*Px!O?V!O!Q*P!Q!^?V!^!_:n!_!a*P!a#o?V#p#q*P#q#s?V#s$f*P$f;'S?V;'S;=`@o<%l?Ah?V?Ah?BY*P?BY?Mn?V?MnO*Pa@rP;=`<%l?V!s@xP;=`<%l=e&{AUm!XP!n&j!b`OX-XXZ*PZ[-X[^*P^p-Xpq*Pqr@{rs*Psv@{vw;owx*Px!O@{!O!Q-X!Q!^@{!^!_:n!_!a*P!a#S@{#S#T?V#T#o@{#o#p,W#p#q-X#q#s@{#s$f-X$f;'S@{;'S;=`CP<%l?Ah@{?Ah?BY-X?BY?Mn@{?MnO-X&{CSP;=`<%l@{(_CYP;=`<%l4}IcChZ!j1r!XP#v7[!W!bOv(nvw)hw!^(n!^!_)h!_#o(n#o#p)h#p#q(n#q#r*P#r;'S(n;'S;=`*n<%lO(nI{DlnbY!XP!n&j#t,U#v7[!W!b!b`OX&|XZ(nZ[&|[^(n^p&|pq(nqr4}rs(nsv4}vw7Wwx(nx!O4}!O!Q&|!Q!^4}!^!_9X!_!a(n!a#S4}#S#T=e#T#o4}#o#p*t#p#q&|#q#r@{#r#s4}#s$f&|$f;'S4};'S;=`CV<%l?Ah4}?Ah?BY&|?BY?Mn4}?MnO&|JkF}vdW!XP!n&j#t,U#v7[#rp!W!b!b`OX&|XZ(nZ[&|[^(n^p&|pq(nqr4}rs(nst4}tuIeuv4}vw7Wwx(nx}4}}!OIe!O!Q&|!Q![Ie![!^4}!^!_9X!_!a(n!a!c4}!c!}Ie!}#R4}#R#SIe#S#T=e#T#oIe#o#p*t#p#q&|#q#r@{#r#s4}#s$f&|$f$g4}$g;'SIe;'S;=`L[<%l?AhIe?Ah?BYLb?BY?MnIe?MnOLb)XItvdW!XP!n&j#rp!W!b!b`OX&|XZ(nZ[&|[^(n^p&|pq(nqr4}rs(nst4}tuIeuv4}vw7Wwx(nx}4}}!OIe!O!Q&|!Q![Ie![!^4}!^!_9X!_!a(n!a!c4}!c!}Ie!}#R4}#R#SIe#S#T=e#T#oIe#o#p*t#p#q&|#q#r@{#r#s4}#s$f&|$f$g4}$g;'SIe;'S;=`L[<%l?AhIe?Ah?BYLb?BY?MnIe?MnOLb)XL_P;=`<%lIe(wLoqdW!XP!n&j#rp!W!bOX&|XZ(nZ[&|[^(n^p&|pq(nqr&|rs(nst&|tuLbuv&|vw*twx(nx}&|}!OLb!O!Q&|!Q![Lb![!^&|!^!_)h!_!a(n!a!c&|!c!}Lb!}#R&|#R#SLb#S#T(n#T#oLb#o#p*t#p#q&|#q#r-X#r$g&|$g;'SLb;'S;=`Nv<%lOLb(wNyP;=`<%lLbIq! Xn!n&j!W!b![Bc!b`OX!#VXZ!$oZ[!#V[^!$o^p!#Vpq)hqr!*krs!$ost!8dtw!*kwx!$ox!O!*k!O!Q!#V!Q!]!*k!]!^7W!^!_!.u!_!a!$o!a#S!*k#S#T!.u#T#o!*k#o#q!#V#q#r!4m#r#s!*k#s$f!#V$f;'S!*k;'S;=`!8^<%l?Ah!*k?Ah?BY!#V?BY?Mn!*k?MnO!#VIa!#^e!n&j!W!bOX!#VXZ!$oZ[!#V[^!$o^p!#Vpq)hqr!#Vrs!$ost*ttw!#Vwx!$ox!]!#V!]!^!&u!^!a!$o!a#S!#V#S#T!$o#T#q!#V#q#r!(Z#r;'S!#V;'S;=`!*e<%lO!#VCu!$tZ!W!bOp!$opq)hqs!$ost)ht!]!$o!]!^!%g!^#q!$o#q#r!%z#r;'S!$o;'S;=`!&o<%lO!$oCu!%nS!W!b!YBcO#q)h#r;'S)h;'S;=`)y<%lO)hBc!%}VOp!%zqs!%zt!]!%z!]!^!&d!^;'S!%z;'S;=`!&i<%lO!%zBc!&iO!YBcBc!&lP;=`<%l!%zCu!&rP;=`<%l!$oIa!'Oc!n&j!W!b!YBcOX*tXZ)hZ[*t[^)h^p*tpq)hqr*trs)hsw*twx)hx!^*t!^!a)h!a#S*t#S#T)h#T#q*t#q#r,W#r;'S*t;'S;=`-R<%lO*tG}!(`b!n&jOX!(ZXZ!%zZ[!(Z[^!%z^p!(Zqr!(Zrs!%zst,Wtw!(Zwx!%zx!]!(Z!]!^!)h!^!a!%z!a#S!(Z#S#T!%z#T;'S!(Z;'S;=`!*_<%lO!(ZG}!)oY!n&j!YBcOX,WZ[,W^p,Wqr,Wsw,Wx!^,W!a#S,W#T;'S,W;'S;=`,{<%lO,WG}!*bP;=`<%l!(ZIa!*hP;=`<%l!#VIq!*tn!n&j!W!b!b`OX!#VXZ!$oZ[!#V[^!$o^p!#Vpq)hqr!*krs!$ost7Wtw!*kwx!$ox!O!*k!O!Q!#V!Q!]!*k!]!^!,r!^!_!.u!_!a!$o!a#S!*k#S#T!.u#T#o!*k#o#q!#V#q#r!4m#r#s!*k#s$f!#V$f;'S!*k;'S;=`!8^<%l?Ah!*k?Ah?BY!#V?BY?Mn!*k?MnO!#VIq!,}l!n&j!W!b!YBc!b`OX*tXZ)hZ[*t[^)h^p*tpq)hqr7Wrs)hsw7Wwx)hx!O7W!O!Q*t!Q!^7W!^!_9X!_!a)h!a#S7W#S#T9X#T#o7W#o#q*t#q#r;o#r#s7W#s$f*t$f;'S7W;'S;=`=_<%l?Ah7W?Ah?BY*t?BY?Mn7W?MnO*tDV!.|h!W!b!b`Op!$opq)hqr!.urs!$ost9Xtw!.uwx!$ox!O!.u!O!Q!$o!Q!]!.u!]!^!0h!^!_!.u!_!a!$o!a#o!.u#o#q!$o#q#r!2P#r#s!.u#s$f!$o$f;'S!.u;'S;=`!4g<%l?Ah!.u?Ah?BY!$o?BY?Mn!.u?MnO!$oDV!0qd!W!b!YBc!b`Oq)hqr9Xrs)hsw9Xwx)hx!O9X!O!Q)h!Q!_9X!_!a)h!a#o9X#o#q)h#q#r:n#r#s9X#s$f)h$f;'S9X;'S;=`;i<%l?Ah9X?Ah?BY)h?BY?Mn9X?MnO)hBs!2Uf!b`Op!%zqr!2Prs!%zst:ntw!2Pwx!%zx!O!2P!O!Q!%z!Q!]!2P!]!^!3j!^!_!2P!_!a!%z!a#o!2P#o#q!%z#q#s!2P#s$f!%z$f;'S!2P;'S;=`!4a<%l?Ah!2P?Ah?BY!%z?BY?Mn!2P?MnO!%zBs!3qY!YBc!b`qr:nsw:nx!O:n!Q!_:n!a#o:n#q#s:n$f;'S:n;'S;=`;c<%l?Ah:n?BY?Mn:nBs!4dP;=`<%l!2PDV!4jP;=`<%l!.uH_!4tl!n&j!b`OX!(ZXZ!%zZ[!(Z[^!%z^p!(Zqr!4mrs!%zst;otw!4mwx!%zx!O!4m!O!Q!(Z!Q!]!4m!]!^!6l!^!_!2P!_!a!%z!a#S!4m#S#T!2P#T#o!4m#o#q!(Z#q#s!4m#s$f!(Z$f;'S!4m;'S;=`!8W<%l?Ah!4m?Ah?BY!(Z?BY?Mn!4m?MnO!(ZH_!6ue!n&j!YBc!b`OX,WZ[,W^p,Wqr;osw;ox!O;o!O!Q,W!Q!^;o!^!_:n!a#S;o#S#T:n#T#o;o#o#q,W#q#s;o#s$f,W$f;'S;o;'S;=`=X<%l?Ah;o?Ah?BY,W?BY?Mn;o?MnO,WH_!8ZP;=`<%l!4mIq!8aP;=`<%l!*kIq!8mm!n&j!W!b!b`OX!:hXZ!;}Z[!:h[^!;}^p!:hpq)hqr!Amrs!;}sw!Amwx!;}x!O!Am!O!Q!:h!Q!]!Am!]!^7W!^!_!Et!_!a!;}!a#S!Am#S#T!Et#T#o!Am#o#q!:h#q#r!Kf#r#s!Am#s$f!:h$f;'S!Am;'S;=`# S<%l?Ah!Am?Ah?BY!:h?BY?Mn!Am?MnO!:hIa!:od!n&j!W!bOX!:hXZ!;}Z[!:h[^!;}^p!:hpq)hqr!:hrs!;}sw!:hwx!;}x!]!:h!]!^!=z!^!a!;}!a#S!:h#S#T!;}#T#q!:h#q#r!?`#r;'S!:h;'S;=`!Ag<%lO!:hCu!<SX!W!bOp!;}pq)hq!]!;}!]!^!<o!^#q!;}#q#r!=S#r;'S!;};'S;=`!=t<%lO!;}Cu!<vS!W!b!ZBcO#q)h#r;'S)h;'S;=`)y<%lO)hBc!=VUOp!=Sq!]!=S!]!^!=i!^;'S!=S;'S;=`!=n<%lO!=SBc!=nO!ZBcBc!=qP;=`<%l!=SCu!=wP;=`<%l!;}Ia!>Tc!n&j!W!b!ZBcOX*tXZ)hZ[*t[^)h^p*tpq)hqr*trs)hsw*twx)hx!^*t!^!a)h!a#S*t#S#T)h#T#q*t#q#r,W#r;'S*t;'S;=`-R<%lO*tG}!?ea!n&jOX!?`XZ!=SZ[!?`[^!=S^p!?`qr!?`rs!=Ssw!?`wx!=Sx!]!?`!]!^!@j!^!a!=S!a#S!?`#S#T!=S#T;'S!?`;'S;=`!Aa<%lO!?`G}!@qY!n&j!ZBcOX,WZ[,W^p,Wqr,Wsw,Wx!^,W!a#S,W#T;'S,W;'S;=`,{<%lO,WG}!AdP;=`<%l!?`Ia!AjP;=`<%l!:hIq!Avm!n&j!W!b!b`OX!:hXZ!;}Z[!:h[^!;}^p!:hpq)hqr!Amrs!;}sw!Amwx!;}x!O!Am!O!Q!:h!Q!]!Am!]!^!Cq!^!_!Et!_!a!;}!a#S!Am#S#T!Et#T#o!Am#o#q!:h#q#r!Kf#r#s!Am#s$f!:h$f;'S!Am;'S;=`# S<%l?Ah!Am?Ah?BY!:h?BY?Mn!Am?MnO!:hIq!C|l!n&j!W!b!ZBc!b`OX*tXZ)hZ[*t[^)h^p*tpq)hqr7Wrs)hsw7Wwx)hx!O7W!O!Q*t!Q!^7W!^!_9X!_!a)h!a#S7W#S#T9X#T#o7W#o#q*t#q#r;o#r#s7W#s$f*t$f;'S7W;'S;=`=_<%l?Ah7W?Ah?BY*t?BY?Mn7W?MnO*tDV!E{g!W!b!b`Op!;}pq)hqr!Etrs!;}sw!Etwx!;}x!O!Et!O!Q!;}!Q!]!Et!]!^!Gd!^!_!Et!_!a!;}!a#o!Et#o#q!;}#q#r!H{#r#s!Et#s$f!;}$f;'S!Et;'S;=`!K`<%l?Ah!Et?Ah?BY!;}?BY?Mn!Et?MnO!;}DV!Gmd!W!b!ZBc!b`Oq)hqr9Xrs)hsw9Xwx)hx!O9X!O!Q)h!Q!_9X!_!a)h!a#o9X#o#q)h#q#r:n#r#s9X#s$f)h$f;'S9X;'S;=`;i<%l?Ah9X?Ah?BY)h?BY?Mn9X?MnO)hBs!IQe!b`Op!=Sqr!H{rs!=Ssw!H{wx!=Sx!O!H{!O!Q!=S!Q!]!H{!]!^!Jc!^!_!H{!_!a!=S!a#o!H{#o#q!=S#q#s!H{#s$f!=S$f;'S!H{;'S;=`!KY<%l?Ah!H{?Ah?BY!=S?BY?Mn!H{?MnO!=SBs!JjY!ZBc!b`qr:nsw:nx!O:n!Q!_:n!a#o:n#q#s:n$f;'S:n;'S;=`;c<%l?Ah:n?BY?Mn:nBs!K]P;=`<%l!H{DV!KcP;=`<%l!EtH_!Kmk!n&j!b`OX!?`XZ!=SZ[!?`[^!=S^p!?`qr!Kfrs!=Ssw!Kfwx!=Sx!O!Kf!O!Q!?`!Q!]!Kf!]!^!Mb!^!_!H{!_!a!=S!a#S!Kf#S#T!H{#T#o!Kf#o#q!?`#q#s!Kf#s$f!?`$f;'S!Kf;'S;=`!N|<%l?Ah!Kf?Ah?BY!?`?BY?Mn!Kf?MnO!?`H_!Mke!n&j!ZBc!b`OX,WZ[,W^p,Wqr;osw;ox!O;o!O!Q,W!Q!^;o!^!_:n!a#S;o#S#T:n#T#o;o#o#q,W#q#s;o#s$f,W$f;'S;o;'S;=`=X<%l?Ah;o?Ah?BY,W?BY?Mn;o?MnO,WH_# PP;=`<%l!KfIq# VP;=`<%l!AmIc# eZ!l<x!XP#t,U!W!bOv(nvw)hw!^(n!^!_)h!_#o(n#o#p)h#p#q(n#q#r*P#r;'S(n;'S;=`*n<%lO(nIs#!go!XP!n&j#t,U#v7[!W!b!b`OX&|XZ(nZ[&|[^(n^p&|pq(nqr4}rs(nsv4}vw7Wwx(nx}4}}!O#$h!O!Q&|!Q!^4}!^!_9X!_!a(n!a#S4}#S#T=e#T#o4}#o#p*t#p#q&|#q#r@{#r#s4}#s$f&|$f;'S4};'S;=`CV<%l?Ah4}?Ah?BY&|?BY?Mn4}?MnO&|(a#$so!XP!n&j!W!b!b`OX&|XZ(nZ[&|[^(n^p&|pq(nqr#&trs(nsv#&tvw#)Pwx(nx!O#&t!O!Q&|!Q!^#&t!^!_#+S!_!`(n!`!a#5d!a#S#&t#S#T#/f#T#o#&t#o#p*t#p#q&|#q#r#6`#r#s#&t#s$f&|$f;'S#&t;'S;=`#5^<%l?Ah#&t?Ah?BY&|?BY?Mn#&t?MnO&|(_#'Rn!XP!n&j!W!b!g`!b`OX&|XZ(nZ[&|[^(n^p&|pq(nqr#&trs(nsv#&tvw#)Pwx(nx!O#&t!O!Q&|!Q!^#&t!^!_#+S!_!a(n!a#S#&t#S#T#/f#T#o#&t#o#p*t#p#q&|#q#r#3Q#r#s#&t#s$f&|$f;'S#&t;'S;=`#5^<%l?Ah#&t?Ah?BY&|?BY?Mn#&t?MnO&|(^#)[l!n&j!W!b!g`!b`OX*tXZ)hZ[*t[^)h^p*tpq)hqr#)Prs)hsw#)Pwx)hx!O#)P!O!Q*t!Q!^#)P!^!_#+S!_!a)h!a#S#)P#S#T#+S#T#o#)P#o#q*t#q#r#-n#r#s#)P#s$f*t$f;'S#)P;'S;=`#/`<%l?Ah#)P?Ah?BY*t?BY?Mn#)P?MnO*t!r#+]d!W!b!g`!b`Oq)hqr#+Srs)hsw#+Swx)hx!O#+S!O!Q)h!Q!_#+S!_!a)h!a#o#+S#o#q)h#q#r#,k#r#s#+S#s$f)h$f;'S#+S;'S;=`#-h<%l?Ah#+S?Ah?BY)h?BY?Mn#+S?MnO)h`#,rY!g`!b`qr#,ksw#,kx!O#,k!Q!_#,k!a#o#,k#q#s#,k$f;'S#,k;'S;=`#-b<%l?Ah#,k?BY?Mn#,k`#-eP;=`<%l#,k!r#-kP;=`<%l#+S&z#-we!n&j!g`!b`OX,WZ[,W^p,Wqr#-nsw#-nx!O#-n!O!Q,W!Q!^#-n!^!_#,k!a#S#-n#S#T#,k#T#o#-n#o#q,W#q#s#-n#s$f,W$f;'S#-n;'S;=`#/Y<%l?Ah#-n?Ah?BY,W?BY?Mn#-n?MnO,W&z#/]P;=`<%l#-n(^#/cP;=`<%l#)P!s#/qg!XP!W!b!g`!b`Oq(nqr#/frs(nsv#/fvw#+Swx(nx!O#/f!O!Q(n!Q!^#/f!^!_#+S!_!a(n!a#o#/f#o#p)h#p#q(n#q#r#1Y#r#s#/f#s$f(n$f;'S#/f;'S;=`#2z<%l?Ah#/f?Ah?BY(n?BY?Mn#/f?MnO(na#1ce!XP!g`!b`Oq*Pqr#1Yrs*Psv#1Yvw#,kwx*Px!O#1Y!O!Q*P!Q!^#1Y!^!_#,k!_!a*P!a#o#1Y#p#q*P#q#s#1Y#s$f*P$f;'S#1Y;'S;=`#2t<%l?Ah#1Y?Ah?BY*P?BY?Mn#1Y?MnO*Pa#2wP;=`<%l#1Y!s#2}P;=`<%l#/f&{#3]m!XP!n&j!g`!b`OX-XXZ*PZ[-X[^*P^p-Xpq*Pqr#3Qrs*Psv#3Qvw#-nwx*Px!O#3Q!O!Q-X!Q!^#3Q!^!_#,k!_!a*P!a#S#3Q#S#T#1Y#T#o#3Q#o#p,W#p#q-X#q#s#3Q#s$f-X$f;'S#3Q;'S;=`#5W<%l?Ah#3Q?Ah?BY-X?BY?Mn#3Q?MnO-X&{#5ZP;=`<%l#3Q(_#5aP;=`<%l#&t!e#5mZ!XP$OQ!W!bOv(nvw)hw!^(n!^!_)h!_#o(n#o#p)h#p#q(n#q#r*P#r;'S(n;'S;=`*n<%lO(n&}#6kn!XP!n&j!g`!b`OX-XXZ*PZ[-X[^*P^p-Xpq*Pqr#3Qrs*Psv#3Qvw#-nwx*Px!O#3Q!O!Q-X!Q!^#3Q!^!_#,k!_!a*P!a#S#3Q#S#T#1Y#T#o#3Q#o#p,W#p#q-X#q#r#8i#r#s#3Q#s$f-X$f;'S#3Q;'S;=`#5W<%l?Ah#3Q?Ah?BY-X?BY?Mn#3Q?MnO-X&}#8vm!XP!n&j#zQ!g`!b`OX-XXZ*PZ[-X[^*P^p-Xpq*Pqr#3Qrs*Psv#3Qvw#-nwx*Px!O#3Q!O!Q-X!Q!^#3Q!^!_#,k!_!a*P!a#S#3Q#S#T#1Y#T#o#3Q#o#p,W#p#q-X#q#s#3Q#s$f-X$f;'S#3Q;'S;=`#5W<%l?Ah#3Q?Ah?BY-X?BY?Mn#3Q?MnO-XIq#;Oi!XP!n&j#t,U#v7[!W!bOX&|XZ(nZ[&|[^(n^p&|pq(nqr&|rs(nsv&|vw*twx(nx!O&|!O!P#<m!P!^&|!^!_)h!_!a(n!a#S&|#S#T(n#T#o&|#o#p*t#p#q&|#q#r-X#r;'S&|;'S;=`.t<%lO&|(_#<vi!XP!n&j!W!bOX&|XZ(nZ[&|[^(n^p&|pq(nqr&|rs(nsv&|vw*twx(nx!O&|!O!P#>e!P!^&|!^!_)h!_!a(n!a#S&|#S#T(n#T#o&|#o#p*t#p#q&|#q#r-X#r;'S&|;'S;=`.t<%lO&|(_#>pg!q`!XP!n&j!W!bOX&|XZ(nZ[&|[^(n^p&|pq(nqr&|rs(nsv&|vw*twx(nx!^&|!^!_)h!_!a(n!a#S&|#S#T(n#T#o&|#o#p*t#p#q&|#q#r-X#r;'S&|;'S;=`.t<%lO&|JP#@hhbY!XP!n&j#t,U#v7[!W!bOX&|XZ(nZ[&|[^(n^p&|pq(nqr&|rs(nsv&|vw*twx(nx!^&|!^!_)h!_!`(n!`!a#BS!a#S&|#S#T(n#T#o&|#o#p*t#p#q&|#q#r-X#r;'S&|;'S;=`.t<%lO&|!w#B_Z!XP!W!b#Q`!rdOv(nvw)hw!^(n!^!_)h!_#o(n#o#p)h#p#q(n#q#r*P#r;'S(n;'S;=`*n<%lO(nJP#Cc!SbY!XP!n&j#t,U#v7[!W!b!b`OX&|XZ(nZ[&|[^(n^p&|pq(nqr4}rs(nsv4}vw7Wwx(nx!O4}!O!Q&|!Q!^4}!^!_9X!_!a(n!a#R4}#R#S#Fo#S#T=e#T#o#Fo#o#p*t#p#q&|#q#r@{#r#s4}#s$f&|$f%W4}%W%o#Fo%o%p4}%p&a#Fo&a&b4}&b1p#Fo1p4U4}4U4d#Fo4d4e4}4e$IS#Fo$IS$I`4}$I`$Ib#Fo$Ib$Kh4}$Kh%#t#Fo%#t&/x4}&/x&Et#Fo&Et&FV4}&FV;'S#Fo;'S;:j#Ny;:j;=`CV<%l?&r4}?&r?Ah#Fo?Ah?BY&|?BY?Mn#Fo?MnO&|(c#F|!]!|S!XP!n&j!W!b!b`OX&|XZ(nZ[&|[^(n^p&|pq(nqr4}rs(nsv4}vw7Wwx(nx}4}}!O#Fo!O!P#Ju!P!Q&|!Q![#Fo![!^4}!^!_9X!_!a(n!a!c4}!c!}#Fo!}#R4}#R#S#Fo#S#T=e#T#o#Fo#o#p*t#p#q&|#q#r@{#r#s4}#s$f&|$f$}4}$}%O#Fo%O%W4}%W%o#Fo%o%p4}%p&a#Fo&a&b4}&b1p#Fo1p4U#Fo4U4d#Fo4d4e4}4e$IS#Fo$IS$I`4}$I`$Ib#Fo$Ib$Je4}$Je$Jg#Fo$Jg$Kh4}$Kh%#t#Fo%#t&/x4}&/x&Et#Fo&Et&FV4}&FV;'S#Fo;'S;:j#Ny;:j;=`CV<%l?&r4}?&r?Ah#Fo?Ah?BY&|?BY?Mn#Fo?MnO&|(R#KQ!Z!|S!XP!n&j!W!bOX&|XZ(nZ[&|[^(n^p&|pq(nqr&|rs(nsv&|vw*twx(nx}&|}!O#Ju!O!P#Ju!P!Q&|!Q![#Ju![!^&|!^!_)h!_!a(n!a!c&|!c!}#Ju!}#R&|#R#S#Ju#S#T(n#T#o#Ju#o#p*t#p#q&|#q#r-X#r$}&|$}%O#Ju%O%W&|%W%o#Ju%o%p&|%p&a#Ju&a&b&|&b1p#Ju1p4U#Ju4U4d#Ju4d4e&|4e$IS#Ju$IS$I`&|$I`$Ib#Ju$Ib$Je&|$Je$Jg#Ju$Jg$Kh&|$Kh%#t#Ju%#t&/x&|&/x&Et#Ju&Et&FV&|&FV;'S#Ju;'S;:j#Ns;:j;=`.t<%l?&r&|?&r?Ah#Ju?Ah?BY&|?BY?Mn#Ju?MnO&|(R#NvP;=`<%l#Ju(c#N|P;=`<%l#FoDV$ [e#t,U#v7[!W!b!b`Oq)hqr$!mrs)hsw9Xwx)hx!O9X!O!Q)h!Q!_9X!_!a)h!a!b$?c!b#o9X#o#q)h#q#r:n#r#s9X#s$f)h$f;'S9X;'S;=`;i<%l?Ah9X?Ah?BY)h?BY?Mn9X?MnO)h!s$!ti!W!b!b`Oq)hqr9Xrs)hsw9Xwx)hx}9X}!O$$c!O!Q)h!Q!_9X!_!a)h!a!f9X!f!g$'d!g#W9X#W#X$5y#X#o9X#o#q)h#q#r:n#r#s9X#s$f)h$f;'S9X;'S;=`;i<%l?Ah9X?Ah?BY)h?BY?Mn9X?MnO)h!s$$je!W!b!b`Oq)hqr9Xrs)hsw9Xwx)hx}9X}!O$%{!O!Q)h!Q!_9X!_!a)h!a#o9X#o#q)h#q#r:n#r#s9X#s$f)h$f;'S9X;'S;=`;i<%l?Ah9X?Ah?BY)h?BY?Mn9X?MnO)h!s$&Ud!W!b#}P!b`Oq)hqr9Xrs)hsw9Xwx)hx!O9X!O!Q)h!Q!_9X!_!a)h!a#o9X#o#q)h#q#r:n#r#s9X#s$f)h$f;'S9X;'S;=`;i<%l?Ah9X?Ah?BY)h?BY?Mn9X?MnO)h!s$'kf!W!b!b`Oq)hqr9Xrs)hsw9Xwx)hx!O9X!O!Q)h!Q!_9X!_!a)h!a!q9X!q!r$)P!r#o9X#o#q)h#q#r:n#r#s9X#s$f)h$f;'S9X;'S;=`;i<%l?Ah9X?Ah?BY)h?BY?Mn9X?MnO)h!s$)Wf!W!b!b`Oq)hqr9Xrs)hsw9Xwx)hx!O9X!O!Q)h!Q!_9X!_!a)h!a!e9X!e!f$*l!f#o9X#o#q)h#q#r:n#r#s9X#s$f)h$f;'S9X;'S;=`;i<%l?Ah9X?Ah?BY)h?BY?Mn9X?MnO)h!s$*sf!W!b!b`Oq)hqr9Xrs)hsw9Xwx)hx!O9X!O!Q)h!Q!_9X!_!a)h!a!v9X!v!w$,X!w#o9X#o#q)h#q#r:n#r#s9X#s$f)h$f;'S9X;'S;=`;i<%l?Ah9X?Ah?BY)h?BY?Mn9X?MnO)h!s$,`f!W!b!b`Oq)hqr9Xrs)hsw9Xwx)hx!O9X!O!Q)h!Q!_9X!_!a)h!a!{9X!{!|$-t!|#o9X#o#q)h#q#r:n#r#s9X#s$f)h$f;'S9X;'S;=`;i<%l?Ah9X?Ah?BY)h?BY?Mn9X?MnO)h!s$-{f!W!b!b`Oq)hqr9Xrs)hsw9Xwx)hx!O9X!O!Q)h!Q!_9X!_!a)h!a!r9X!r!s$/a!s#o9X#o#q)h#q#r:n#r#s9X#s$f)h$f;'S9X;'S;=`;i<%l?Ah9X?Ah?BY)h?BY?Mn9X?MnO)h!s$/hf!W!b!b`Oq)hqr9Xrs)hsw9Xwx)hx!O9X!O!Q)h!Q!_9X!_!a)h!a!g9X!g!h$0|!h#o9X#o#q)h#q#r:n#r#s9X#s$f)h$f;'S9X;'S;=`;i<%l?Ah9X?Ah?BY)h?BY?Mn9X?MnO)h!s$1Te!W!b!b`Oq$2fqr$0|rs$2fsw$0|wx$2fx!O$0|!O!Q$2f!Q!_$0|!_!`$2f!`!a$3Q!a#o$0|#o#q$2f#q#r$4Y#r#s$0|#s$f$2f$f;'S$0|;'S;=`$5s<%l?Ah$0|?Ah?BY$2f?BY?Mn$0|?MnO$2f!c$2kV!W!bO!`$2f!`!a$3Q!a#q$2f#q#r$3e#r;'S$2f;'S;=`$4S<%lO$2f!c$3XS!W!b#XPO#q)h#r;'S)h;'S;=`)y<%lO)hP$3hTO!`$3e!`!a$3w!a;'S$3e;'S;=`$3|<%lO$3eP$3|O#XPP$4PP;=`<%l$3e!c$4VP;=`<%l$2fa$4_d!b`Oq$3eqr$4Yrs$3esw$4Ywx$3ex!O$4Y!O!Q$3e!Q!_$4Y!_!`$3e!`!a$3w!a#o$4Y#o#q$3e#q#s$4Y#s$f$3e$f;'S$4Y;'S;=`$5m<%l?Ah$4Y?Ah?BY$3e?BY?Mn$4Y?MnO$3ea$5pP;=`<%l$4Y!s$5vP;=`<%l$0|!s$6Qf!W!b!b`Oq)hqr9Xrs)hsw9Xwx)hx!O9X!O!Q)h!Q!_9X!_!a)h!a#c9X#c#d$7f#d#o9X#o#q)h#q#r:n#r#s9X#s$f)h$f;'S9X;'S;=`;i<%l?Ah9X?Ah?BY)h?BY?Mn9X?MnO)h!s$7mf!W!b!b`Oq)hqr9Xrs)hsw9Xwx)hx!O9X!O!Q)h!Q!_9X!_!a)h!a#V9X#V#W$9R#W#o9X#o#q)h#q#r:n#r#s9X#s$f)h$f;'S9X;'S;=`;i<%l?Ah9X?Ah?BY)h?BY?Mn9X?MnO)h!s$9Yf!W!b!b`Oq)hqr9Xrs)hsw9Xwx)hx!O9X!O!Q)h!Q!_9X!_!a)h!a#h9X#h#i$:n#i#o9X#o#q)h#q#r:n#r#s9X#s$f)h$f;'S9X;'S;=`;i<%l?Ah9X?Ah?BY)h?BY?Mn9X?MnO)h!s$:uf!W!b!b`Oq)hqr9Xrs)hsw9Xwx)hx!O9X!O!Q)h!Q!_9X!_!a)h!a#m9X#m#n$<Z#n#o9X#o#q)h#q#r:n#r#s9X#s$f)h$f;'S9X;'S;=`;i<%l?Ah9X?Ah?BY)h?BY?Mn9X?MnO)h!s$<bf!W!b!b`Oq)hqr9Xrs)hsw9Xwx)hx!O9X!O!Q)h!Q!_9X!_!a)h!a#d9X#d#e$=v#e#o9X#o#q)h#q#r:n#r#s9X#s$f)h$f;'S9X;'S;=`;i<%l?Ah9X?Ah?BY)h?BY?Mn9X?MnO)h!s$=}f!W!b!b`Oq)hqr9Xrs)hsw9Xwx)hx!O9X!O!Q)h!Q!_9X!_!a)h!a#X9X#X#Y$0|#Y#o9X#o#q)h#q#r:n#r#s9X#s$f)h$f;'S9X;'S;=`;i<%l?Ah9X?Ah?BY)h?BY?Mn9X?MnO)h!s$?je!W!b!b`Oq$@{qr$?crs$@{sw$?cwx$@{x!O$?c!O!Q$@{!Q!_$?c!_!a$@{!a!b$Cm!b#o$?c#o#q$@{#q#r$EV#r#s$?c#s$f$@{$f;'S$?c;'S;=`$HT<%l?Ah$?c?Ah?BY$@{?BY?Mn$?c?MnO$@{!c$AQV!W!bO!a$@{!a!b$Ag!b#q$@{#q#r$Bf#r;'S$@{;'S;=`$Cg<%lO$@{!c$AlV!W!bO!`$@{!`!a$BR!a#q$@{#q#r$Bf#r;'S$@{;'S;=`$Cg<%lO$@{!c$BYS!W!b#UPO#q)h#r;'S)h;'S;=`)y<%lO)hP$BiTO!a$Bf!a!b$Bx!b;'S$Bf;'S;=`$Ca<%lO$BfP$B{TO!`$Bf!`!a$C[!a;'S$Bf;'S;=`$Ca<%lO$BfP$CaO#UPP$CdP;=`<%l$Bf!c$CjP;=`<%l$@{!s$Cte!W!b!b`Oq$@{qr$?crs$@{sw$?cwx$@{x!O$?c!O!Q$@{!Q!_$?c!_!`$@{!`!a$BR!a#o$?c#o#q$@{#q#r$EV#r#s$?c#s$f$@{$f;'S$?c;'S;=`$HT<%l?Ah$?c?Ah?BY$@{?BY?Mn$?c?MnO$@{a$E[d!b`Oq$Bfqr$EVrs$Bfsw$EVwx$Bfx!O$EV!O!Q$Bf!Q!_$EV!_!a$Bf!a!b$Fj!b#o$EV#o#q$Bf#q#s$EV#s$f$Bf$f;'S$EV;'S;=`$G}<%l?Ah$EV?Ah?BY$Bf?BY?Mn$EV?MnO$Bfa$Fod!b`Oq$Bfqr$EVrs$Bfsw$EVwx$Bfx!O$EV!O!Q$Bf!Q!_$EV!_!`$Bf!`!a$C[!a#o$EV#o#q$Bf#q#s$EV#s$f$Bf$f;'S$EV;'S;=`$G}<%l?Ah$EV?Ah?BY$Bf?BY?Mn$EV?MnO$Bfa$HQP;=`<%l$EV!s$HWP;=`<%l$?cDV$HhZ!h`!XP#t,U#v7[!W!bOv(nvw)hw!^(n!^!_)h!_#o(n#o#p)h#p#q(n#q#r*P#r;'S(n;'S;=`*n<%lO(nDZ$IhZ!XP#t,U#v7[!W!b!rdOv(nvw)hw!^(n!^!_)h!_#o(n#o#p)h#p#q(n#q#r*P#r;'S(n;'S;=`*n<%lO(nJo$Jp!`dW!}S!XP!n&j#t,U#v7[#rp!W!b!b`OX&|XZ(nZ[&|[^(n^p&|pq(nqr4}rs(nst4}tuIeuv4}vw7Wwx(nx}4}}!O$Nr!O!P%%V!P!Q&|!Q![$Nr![!^4}!^!_9X!_!a(n!a!c4}!c!}$Nr!}#R4}#R#S$Nr#S#T=e#T#o$Nr#o#p*t#p#q&|#q#r@{#r#s4}#s$f&|$f$g4}$g$}Ie$}%O$Nr%O%WIe%W%o$Nr%o%pIe%p&a$Nr&a&bIe&b1p$Nr1p4U$Nr4U4d$Nr4d4eIe4e$IS$Nr$IS$I`Ie$I`$Ib$Nr$Ib$JeIe$Je$Jg$Nr$Jg$KhIe$Kh%#t$Nr%#t&/xIe&/x&Et$Nr&Et&FVIe&FV;'S$Nr;'S;:j%)Z;:j;=`L[<%l?&rIe?&r?Ah$Nr?Ah?BYLb?BY?Mn$Nr?MnOLb)]% T!`dW!}S!XP!n&j#rp!W!b!b`OX&|XZ(nZ[&|[^(n^p&|pq(nqr4}rs(nst4}tuIeuv4}vw7Wwx(nx}4}}!O$Nr!O!P%%V!P!Q&|!Q![$Nr![!^4}!^!_9X!_!a(n!a!c4}!c!}$Nr!}#R4}#R#S$Nr#S#T=e#T#o$Nr#o#p*t#p#q&|#q#r@{#r#s4}#s$f&|$f$g4}$g$}Ie$}%O$Nr%O%WIe%W%o$Nr%o%pIe%p&a$Nr&a&bIe&b1p$Nr1p4U$Nr4U4d$Nr4d4eIe4e$IS$Nr$IS$I`Ie$I`$Ib$Nr$Ib$JeIe$Je$Jg$Nr$Jg$KhIe$Kh%#t$Nr%#t&/xIe&/x&Et$Nr&Et&FVIe&FV;'S$Nr;'S;:j%)Z;:j;=`L[<%l?&rIe?&r?Ah$Nr?Ah?BYLb?BY?Mn$Nr?MnOLb(R%%b!Z!}S!XP!n&j!W!bOX&|XZ(nZ[&|[^(n^p&|pq(nqr&|rs(nsv&|vw*twx(nx}&|}!O%%V!O!P%%V!P!Q&|!Q![%%V![!^&|!^!_)h!_!a(n!a!c&|!c!}%%V!}#R&|#R#S%%V#S#T(n#T#o%%V#o#p*t#p#q&|#q#r-X#r$}&|$}%O%%V%O%W&|%W%o%%V%o%p&|%p&a%%V&a&b&|&b1p%%V1p4U%%V4U4d%%V4d4e&|4e$IS%%V$IS$I`&|$I`$Ib%%V$Ib$Je&|$Je$Jg%%V$Jg$Kh&|$Kh%#t%%V%#t&/x&|&/x&Et%%V&Et&FV&|&FV;'S%%V;'S;:j%)T;:j;=`.t<%l?&r&|?&r?Ah%%V?Ah?BY&|?BY?Mn%%V?MnO&|(R%)WP;=`<%l%%V)]%)^P;=`<%l$NrJq%)v!`dW!_U!XP!n&j#t,U#v7[#rp!W!b!b`OX&|XZ(nZ[&|[^(n^p&|pq(nqr4}rs(nst4}tuIeuv4}vw7Wwx(nx}4}}!O%-x!O!P%2]!P!Q&|!Q![%-x![!^4}!^!_9X!_!a(n!a!c4}!c!}%-x!}#R4}#R#S%-x#S#T=e#T#o%-x#o#p*t#p#q&|#q#r@{#r#s4}#s$f&|$f$g4}$g$}Ie$}%O%-x%O%WIe%W%o%-x%o%pIe%p&a%-x&a&bIe&b1p%-x1p4U%-x4U4d%-x4d4eIe4e$IS%-x$IS$I`Ie$I`$Ib%-x$Ib$JeIe$Je$Jg%-x$Jg$KhIe$Kh%#t%-x%#t&/xIe&/x&Et%-x&Et&FVIe&FV;'S%-x;'S;:j%6a;:j;=`L[<%l?&rIe?&r?Ah%-x?Ah?BYLb?BY?Mn%-x?MnOLb)_%.Z!`dW!_U!XP!n&j#rp!W!b!b`OX&|XZ(nZ[&|[^(n^p&|pq(nqr4}rs(nst4}tuIeuv4}vw7Wwx(nx}4}}!O%-x!O!P%2]!P!Q&|!Q![%-x![!^4}!^!_9X!_!a(n!a!c4}!c!}%-x!}#R4}#R#S%-x#S#T=e#T#o%-x#o#p*t#p#q&|#q#r@{#r#s4}#s$f&|$f$g4}$g$}Ie$}%O%-x%O%WIe%W%o%-x%o%pIe%p&a%-x&a&bIe&b1p%-x1p4U%-x4U4d%-x4d4eIe4e$IS%-x$IS$I`Ie$I`$Ib%-x$Ib$JeIe$Je$Jg%-x$Jg$KhIe$Kh%#t%-x%#t&/xIe&/x&Et%-x&Et&FVIe&FV;'S%-x;'S;:j%6a;:j;=`L[<%l?&rIe?&r?Ah%-x?Ah?BYLb?BY?Mn%-x?MnOLb(T%2h!Z!_U!XP!n&j!W!bOX&|XZ(nZ[&|[^(n^p&|pq(nqr&|rs(nsv&|vw*twx(nx}&|}!O%2]!O!P%2]!P!Q&|!Q![%2]![!^&|!^!_)h!_!a(n!a!c&|!c!}%2]!}#R&|#R#S%2]#S#T(n#T#o%2]#o#p*t#p#q&|#q#r-X#r$}&|$}%O%2]%O%W&|%W%o%2]%o%p&|%p&a%2]&a&b&|&b1p%2]1p4U%2]4U4d%2]4d4e&|4e$IS%2]$IS$I`&|$I`$Ib%2]$Ib$Je&|$Je$Jg%2]$Jg$Kh&|$Kh%#t%2]%#t&/x&|&/x&Et%2]&Et&FV&|&FV;'S%2];'S;:j%6Z;:j;=`.t<%l?&r&|?&r?Ah%2]?Ah?BY&|?BY?Mn%2]?MnO&|(T%6^P;=`<%l%2])_%6dP;=`<%l%-xDV%6tg!XP#t,U#v7[!W!b!b`Oq(nqr=ers(nsv=evw9Xwx(nx!O=e!O!Q(n!Q!^=e!^!_9X!_!a(n!a#o=e#o#p)h#p#q(n#q#r?V#r#s=e#s$f(n$f;'S=e;'S;=`@u<%l?Ah=e?Ah?BY(n?BY?Mn=e?MnO(nMg%8r!bdW!_U!XP!n&j#t,U#v7[#rp!W!b!b`OX&|XZ(nZ[&|[^(n^p&|pq(nqr4}rs(nst4}tuIeuv4}vw7Wwx(nx}4}}!O%-x!O!P%2]!P!Q&|!Q![%-x![!^4}!^!_9X!_!a(n!a!c4}!c!}%-x!}#R4}#R#S%-x#S#T=e#T#h%-x#h#i%<z#i#o%-x#o#p*t#p#q&|#q#r@{#r#s4}#s$f&|$f$g4}$g$}Ie$}%O%-x%O%WIe%W%o%-x%o%pIe%p&a%-x&a&bIe&b1p%-x1p4U%-x4U4d%-x4d4eIe4e$IS%-x$IS$I`Ie$I`$Ib%-x$Ib$JeIe$Je$Jg%-x$Jg$KhIe$Kh%#t%-x%#t&/xIe&/x&Et%-x&Et&FVIe&FV;'S%-x;'S;:j%6a;:j;=`L[<%l?&rIe?&r?Ah%-x?Ah?BYLb?BY?Mn%-x?MnOLb,T%=]!bdW!_U!XP!n&j#rp!W!b!b`OX&|XZ(nZ[&|[^(n^p&|pq(nqr4}rs(nst4}tuIeuv4}vw7Wwx(nx}4}}!O%-x!O!P%2]!P!Q&|!Q![%-x![!^4}!^!_9X!_!a(n!a!c4}!c!}%-x!}#R4}#R#S%-x#S#T=e#T#h%-x#h#i%Ae#i#o%-x#o#p*t#p#q&|#q#r@{#r#s4}#s$f&|$f$g4}$g$}Ie$}%O%-x%O%WIe%W%o%-x%o%pIe%p&a%-x&a&bIe&b1p%-x1p4U%-x4U4d%-x4d4eIe4e$IS%-x$IS$I`Ie$I`$Ib%-x$Ib$JeIe$Je$Jg%-x$Jg$KhIe$Kh%#t%-x%#t&/xIe&/x&Et%-x&Et&FVIe&FV;'S%-x;'S;:j%6a;:j;=`L[<%l?&rIe?&r?Ah%-x?Ah?BYLb?BY?Mn%-x?MnOLb,T%Av!bdW!_U!XP!n&j#rp!W!b!b`OX&|XZ(nZ[&|[^(n^p&|pq(nqr4}rs(nst4}tuIeuv4}vw7Wwx(nx}4}}!O%-x!O!P%2]!P!Q&|!Q![%-x![!^4}!^!_9X!_!a(n!a!c4}!c!}%-x!}#R4}#R#S%-x#S#T=e#T#f%-x#f#g%FO#g#o%-x#o#p*t#p#q&|#q#r@{#r#s4}#s$f&|$f$g4}$g$}Ie$}%O%-x%O%WIe%W%o%-x%o%pIe%p&a%-x&a&bIe&b1p%-x1p4U%-x4U4d%-x4d4eIe4e$IS%-x$IS$I`Ie$I`$Ib%-x$Ib$JeIe$Je$Jg%-x$Jg$KhIe$Kh%#t%-x%#t&/xIe&/x&Et%-x&Et&FVIe&FV;'S%-x;'S;:j%6a;:j;=`L[<%l?&rIe?&r?Ah%-x?Ah?BYLb?BY?Mn%-x?MnOLb,T%Fa!bdW!_U!XP!n&j#rp!W!b!b`OX&|XZ(nZ[&|[^(n^p&|pq(nqr4}rs(nst4}tuIeuv4}vw7Wwx(nx}4}}!O%-x!O!P%2]!P!Q&|!Q![%-x![!^4}!^!_9X!_!a(n!a!c4}!c!}%-x!}#R4}#R#S%-x#S#T=e#T#]%-x#]#^%Ji#^#o%-x#o#p*t#p#q&|#q#r@{#r#s4}#s$f&|$f$g4}$g$}Ie$}%O%-x%O%WIe%W%o%-x%o%pIe%p&a%-x&a&bIe&b1p%-x1p4U%-x4U4d%-x4d4eIe4e$IS%-x$IS$I`Ie$I`$Ib%-x$Ib$JeIe$Je$Jg%-x$Jg$KhIe$Kh%#t%-x%#t&/xIe&/x&Et%-x&Et&FVIe&FV;'S%-x;'S;:j%6a;:j;=`L[<%l?&rIe?&r?Ah%-x?Ah?BYLb?BY?Mn%-x?MnOLb,T%Jz!bdW!_U!XP!n&j#rp!W!b!b`OX&|XZ(nZ[&|[^(n^p&|pq(nqr4}rs(nst4}tuIeuv4}vw7Wwx(nx}4}}!O%-x!O!P%2]!P!Q&|!Q![%-x![!^4}!^!_9X!_!a(n!a!c4}!c!}%-x!}#R4}#R#S%-x#S#T=e#T#U%-x#U#V& S#V#o%-x#o#p*t#p#q&|#q#r@{#r#s4}#s$f&|$f$g4}$g$}Ie$}%O%-x%O%WIe%W%o%-x%o%pIe%p&a%-x&a&bIe&b1p%-x1p4U%-x4U4d%-x4d4eIe4e$IS%-x$IS$I`Ie$I`$Ib%-x$Ib$JeIe$Je$Jg%-x$Jg$KhIe$Kh%#t%-x%#t&/xIe&/x&Et%-x&Et&FVIe&FV;'S%-x;'S;:j%6a;:j;=`L[<%l?&rIe?&r?Ah%-x?Ah?BYLb?BY?Mn%-x?MnOLb,T& e!bdW!_U!XP!n&j#rp!W!b!b`OX&|XZ(nZ[&|[^(n^p&|pq(nqr4}rs(nst4}tuIeuv4}vw7Wwx(nx}4}}!O%-x!O!P%2]!P!Q&|!Q![%-x![!^4}!^!_9X!_!a(n!a!c4}!c!}%-x!}#R4}#R#S%-x#S#T=e#T#i%-x#i#j&%m#j#o%-x#o#p*t#p#q&|#q#r@{#r#s4}#s$f&|$f$g4}$g$}Ie$}%O%-x%O%WIe%W%o%-x%o%pIe%p&a%-x&a&bIe&b1p%-x1p4U%-x4U4d%-x4d4eIe4e$IS%-x$IS$I`Ie$I`$Ib%-x$Ib$JeIe$Je$Jg%-x$Jg$KhIe$Kh%#t%-x%#t&/xIe&/x&Et%-x&Et&FVIe&FV;'S%-x;'S;:j%6a;:j;=`L[<%l?&rIe?&r?Ah%-x?Ah?BYLb?BY?Mn%-x?MnOLb,T&&O!bdW!_U!XP!n&j#rp!W!b!b`OX&|XZ(nZ[&|[^(n^p&|pq(nqr4}rs(nst4}tuIeuv4}vw7Wwx(nx}4}}!O%-x!O!P%2]!P!Q&|!Q![%-x![!^4}!^!_9X!_!a(n!a!c4}!c!}%-x!}#R4}#R#S%-x#S#T=e#T#h%-x#h#i&*W#i#o%-x#o#p*t#p#q&|#q#r@{#r#s4}#s$f&|$f$g4}$g$}Ie$}%O%-x%O%WIe%W%o%-x%o%pIe%p&a%-x&a&bIe&b1p%-x1p4U%-x4U4d%-x4d4eIe4e$IS%-x$IS$I`Ie$I`$Ib%-x$Ib$JeIe$Je$Jg%-x$Jg$KhIe$Kh%#t%-x%#t&/xIe&/x&Et%-x&Et&FVIe&FV;'S%-x;'S;:j%6a;:j;=`L[<%l?&rIe?&r?Ah%-x?Ah?BYLb?BY?Mn%-x?MnOLb,T&*i!bdW!_U!XP!n&j#rp!W!b!b`OX&|XZ(nZ[&|[^(n^p&|pq(nqr4}rs(nst4}tuIeuv4}vw7Wwx(nx}4}}!O%-x!O!P%2]!P!Q&|!Q![%-x![!^4}!^!_9X!_!a(n!a!c4}!c!}%-x!}#R4}#R#S%-x#S#T=e#T#X%-x#X#Y&.q#Y#o%-x#o#p*t#p#q&|#q#r@{#r#s4}#s$f&|$f$g4}$g$}Ie$}%O%-x%O%WIe%W%o%-x%o%pIe%p&a%-x&a&bIe&b1p%-x1p4U%-x4U4d%-x4d4eIe4e$IS%-x$IS$I`Ie$I`$Ib%-x$Ib$JeIe$Je$Jg%-x$Jg$KhIe$Kh%#t%-x%#t&/xIe&/x&Et%-x&Et&FVIe&FV;'S%-x;'S;:j%6a;:j;=`L[<%l?&rIe?&r?Ah%-x?Ah?BYLb?BY?Mn%-x?MnOLb,T&/S!bdW!_U!XP!n&j#rp!W!b!b`OX&|XZ(nZ[&|[^(n^p&|pq(nqr4}rs(nst4}tuIeuv4}vw7Wwx(nx}4}}!O%-x!O!P%2]!P!Q&|!Q![%-x![!^4}!^!_9X!_!a(n!a!c4}!c!}%-x!}#R4}#R#S%-x#S#T=e#T#g%-x#g#h&3[#h#o%-x#o#p*t#p#q&|#q#r@{#r#s4}#s$f&|$f$g4}$g$}Ie$}%O%-x%O%WIe%W%o%-x%o%pIe%p&a%-x&a&bIe&b1p%-x1p4U%-x4U4d%-x4d4eIe4e$IS%-x$IS$I`Ie$I`$Ib%-x$Ib$JeIe$Je$Jg%-x$Jg$KhIe$Kh%#t%-x%#t&/xIe&/x&Et%-x&Et&FVIe&FV;'S%-x;'S;:j%6a;:j;=`L[<%l?&rIe?&r?Ah%-x?Ah?BYLb?BY?Mn%-x?MnOLb,T&3o!`#w#tdW!_U!XP!n&j#rp!W!b!b`OX&|XZ(nZ[&|[^(n^p&|pq(nqr4}rs(nst4}tuIeuv4}vw7Wwx(nx}4}}!O%-x!O!P%2]!P!Q&|!Q![%-x![!^4}!^!_9X!_!a(n!a!c4}!c!}%-x!}#R4}#R#S%-x#S#T=e#T#o%-x#o#p*t#p#q&|#q#r@{#r#s4}#s$f&|$f$g4}$g$}Ie$}%O%-x%O%WIe%W%o%-x%o%pIe%p&a%-x&a&bIe&b1p%-x1p4U%-x4U4d%-x4d4eIe4e$IS%-x$IS$I`Ie$I`$Ib%-x$Ib$JeIe$Je$Jg%-x$Jg$KhIe$Kh%#t%-x%#t&/xIe&/x&Et%-x&Et&FVIe&FV;'S%-x;'S;:j%6a;:j;=`L[<%l?&rIe?&r?Ah%-x?Ah?BYLb?BY?Mn%-x?MnOLbIq&7vU!W!bO#o)h#o#p&8Y#p#q)h#r;'S)h;'S;=`)y<%lO)hIq&8aWaH_!W!bOq)hqr&8yr#o)h#o#p&:`#p#q)h#r;'S)h;'S;=`)y<%lO)h!c&9QU!W!b#{PO})h}!O&9d!O#q)h#r;'S)h;'S;=`)y<%lO)h!c&9iU!W!bO})h}!O&9{!O#q)h#r;'S)h;'S;=`)y<%lO)h!c&:SS!W!b#yPO#q)h#r;'S)h;'S;=`)y<%lO)h!c&:gS!SP!W!bO#q)h#r;'S)h;'S;=`)y<%lO)hIq&;Sg!d`!XP!n&j#t,U#v7[!W!bOX&|XZ(nZ[&|[^(n^p&|pq(nqr&|rs(nsv&|vw*twx(nx!^&|!^!_)h!_!a(n!a#S&|#S#T(n#T#o&|#o#p*t#p#q&|#q#r-X#r;'S&|;'S;=`.t<%lO&|Jq&<xn!XP!n&j#t,U#v7[!b`OX-XXZ*PZ[-X[^*P^p-Xpq*Pqr@{rs*Psv@{vw;owx*Px!O@{!O!Q-X!Q!^@{!^!_:n!_!a*P!a#S@{#S#T?V#T#o@{#o#p,W#p#q-X#q#r&>v#r#s@{#s$f-X$f;'S@{;'S;=`CP<%l?Ah@{?Ah?BY-X?BY?Mn@{?MnO-X)_&?Tnf#[!XP!n&j#|Q!b`OX-XXZ*PZ[-X[^*P^p-Xpq*Pqr@{rs*Psv@{vw;owx*Px!O@{!O!Q-X!Q!^@{!^!_:n!_!a*P!a#S@{#S#T?V#T#o@{#o#p,W#p#q-X#q#r&AR#r#s@{#s$f-X$f;'S@{;'S;=`CP<%l?Ah@{?Ah?BY-X?BY?Mn@{?MnO-X'P&A^m!TS!XP!n&j!b`OX-XXZ*PZ[-X[^*P^p-Xpq*Pqr@{rs*Psv@{vw;owx*Px!O@{!O!Q-X!Q!^@{!^!_:n!_!a*P!a#S@{#S#T?V#T#o@{#o#p,W#p#q-X#q#s@{#s$f-X$f;'S@{;'S;=`CP<%l?Ah@{?Ah?BY-X?BY?Mn@{?MnO-XJq&C[P;=`<%l%)aJk&CbP;=`<%lFjJZ&CvqdW!XP!n&j#t,U#v7[#rp!W!bOX&|XZ(nZ[&|[^(n^p&|pq(nqr&|rs(nst&|tuLbuv&|vw*twx(nx}&|}!OLb!O!Q&|!Q![Lb![!^&|!^!_)h!_!a(n!a!c&|!c!}Lb!}#R&|#R#SLb#S#T(n#T#oLb#o#p*t#p#q&|#q#r-X#r$g&|$g;'SLb;'S;=`Nv<%lOLb",
  tokenizers: [scriptTokens, styleTokens, textareaTokens, tagStart, commentContent, moustacheCommentContent, longMoustacheCommentContent, longExpression, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  topRules: {"Document":[0,14]},
  specialized: [{term: 18, get: (value) => spec_BlockPrefix[value] || -1},{term: 20, get: (value) => spec_BlockType[value] || -1},{term: 126, get: (value) => spec_identifier[value] || -1},{term: 64, get: (value) => spec_AttributeName[value] || -1}],
  tokenPrec: 1275
});

function getAttrs(element, input) {
    let attrs = Object.create(null);
    if (!element)
        return attrs;
    if (!element.firstChild)
        return attrs;
    for (let att of element.firstChild.getChildren('Attribute')) {
        let name = att.getChild('AttributeName'), value = att.getChild('AttributeValue') || att.getChild('UnquotedAttributeValue');
        if (name)
            attrs[input.read(name.from, name.to)] = !value
                ? ''
                : value.name == 'AttributeValue'
                    ? input.read(value.from + 1, value.to - 1)
                    : input.read(value.from, value.to);
    }
    return attrs;
}
function maybeNest(node, input, tags) {
    let attrs = {};
    for (let tag of tags) {
        if (!tag.attrs)
            return { parser: tag.parser };
        let evaluatedAttrs = attrs || getAttrs(node.node.parent, input);
        if (tag.attrs(evaluatedAttrs))
            return { parser: tag.parser };
    }
    return null;
}
function configureNesting(tags) {
    let script = [];
    let style = [];
    let textarea = [];
    for (let tag of tags) {
        let array = tag.tag == 'script'
            ? script
            : tag.tag == 'style'
                ? style
                : tag.tag == 'textarea'
                    ? textarea
                    : null;
        if (!array)
            throw new RangeError('Only script, style, and textarea tags can host nested parsers');
        array.push(tag);
    }
    return parseMixed((node, input) => {
        let id = node.type.id;
        if (id === LongExpression)
            return { parser: parser$1 };
        if (id === ScriptText)
            return maybeNest(node, input, script);
        if (id === StyleText)
            return maybeNest(node, input, style);
        if (id === TextareaText)
            return maybeNest(node, input, textarea);
        return null;
    });
}

const glimmerParser = parser;

export { configureNesting, glimmerParser };
